import styles from './slideItem.module.scss';
export default function SlideItem(props) {
  return (
    <div className={`${styles['slide-item']}`}>
      <div className={styles['item-number']}>
        {('00' + props.number).substr(-2)}
      </div>
      <img
        src={props.src}
        alt=""
        onClick={() => props.display(props.number - 1)}
      />
    </div>
  );
}
